import React from "react"

function IconChatHeadphones({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chat-headphones"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chat-headphones"
      {...props}
    >
      <path
        d="M20.183 3.436c.825 0 1.504.63 1.58 1.436l.008.153v17.18c0 .57-.666.853-1.075.503l-.074-.073-3.056-3.52H3.934a1.59 1.59 0 0 1-1.56-1.289l-.021-.149-.008-.153v-12.5c0-.824.631-1.503 1.436-1.58l.153-.008h16.249zm0 1.31H3.933a.28.28 0 0 0-.271.215l-.008.064v12.5c0 .133.093.244.216.273l.064.008h13.93c.152 0 .298.052.414.147l.08.078 2.103 2.42.001-15.426a.28.28 0 0 0-.146-.245l-.07-.027-.063-.008zm-8.185 1.038a4.847 4.847 0 0 1 4.589 3.324l.104.001c.56 0 1.02.421 1.083.964l.008.127v2.345c0 .56-.421 1.021-.964 1.084l-.127.007h-.09c-.218 1.002-.758 1.662-1.524 1.992a2.808 2.808 0 0 1-.65.19v.175a.873.873 0 0 1-.763.866l-.11.006h-1.663a.873.873 0 0 1-.866-.763l-.007-.11v-1.2c0-.444.333-.811.763-.865l.11-.007h1.664c.444 0 .812.333.865.763l.002.02c.075-.02.15-.046.223-.077.386-.166.674-.476.832-.995a1.094 1.094 0 0 1-.96-.958l-.008-.128V10.2c0-.542.396-.992.914-1.077a3.748 3.748 0 0 0-3.425-2.248c-1.5 0-2.827.9-3.422 2.237a1.09 1.09 0 0 1 1.017.966l.007.122v2.345c0 .56-.421 1.021-.964 1.084l-.127.007H7.42c-.56 0-1.021-.42-1.084-.963l-.008-.128V10.2c0-.56.421-1.02.964-1.084l.117-.007c.66-1.967 2.492-3.325 4.59-3.325zm1.338 9.226H12.11v.764h1.227v-.764zm3.355-4.81H15.6v2.345h1.09V10.2zm-8.182 0H7.42v2.345h1.09V10.2z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChatHeadphones
